import * as React from 'react';
import s from './App.scss';
import PageHeader from '../../containers/PageHeader';
import BasicLayout from '../../containers/BasicLayout';
import SingleArticle from '../../containers/SingleArticle';
import Subscription from '../../containers/Subscription';
import {Route, Switch, withRouter, RouteComponentProps} from 'react-router-dom';
import * as utils from '../../utils';
import * as seo from '../../utils/seo';
import {ROUTE_CLIENT, ROUTE_ARTICLE} from '../../../server/routes/config';
import {withTranslation, WithTranslation} from 'react-i18next';
import fedopsLogger from '../../utils/fedopsLogger';
import {stripSearch} from '../../utils/search';
import {History} from 'history';
import {Experiment} from '../../reducers/experiments';
import {Fullscreen} from '../Subscription/Fullscreen';

export interface AppProps extends RouteComponentProps, WithTranslation {
  experiments?: Experiment[];
  loadArticles?: (...args: any[]) => any;
  hasResults?: (...args: any[]) => any;
  sending?: (...args: any[]) => any;
  articles?: any[];
  basePath?: string;
  history: History;
}

export class App extends React.Component<AppProps, {}> {
  constructor(props) {
    super(props);
    this.props.history.listen(location => {
      const route = utils.getRouteData(location.pathname, this.props.experiments);
      const search = stripSearch(location.search);
      const page = utils.getPageIndex(location.pathname);
      this.props.loadArticles(route.tag, page, search);
    });
  }
  componentDidMount() {
    fedopsLogger.appLoaded();
    seo.removeDuplicatedSEOTags();
    this.doUpdate();
  }
  componentDidUpdate() {
    this.doUpdate();
  }

  render() {
    const {t, experiments = [], basePath} = this.props;
    return (
      <main data-hooks="app-component" className={s.root}>
        <Switch>
          <Route
            path={ROUTE_ARTICLE}
            exact
            render={() => (
              <div data-hooks="page" className={`${s.page} ${s.container}`}>
                <SingleArticle experiments={experiments}/>
              </div>
            )}
          />
          <Route
            path={ROUTE_CLIENT}
            exact
            render={({history}) => {
              const route = utils.getRouteData(
                history.location.pathname,
                experiments
              );

              const page = utils.getPageIndex(history.location.pathname);

              const pageHeader = <PageHeader label={route.label} history={history} routeType={route.type} />;

              const url = `${basePath}${history.location.pathname}`;

              const routeLabel = t(route.label);
              const titleTranslationKey = page === 1 ? 'seo.title' : 'seo.title.subpage';
              const pageSEOTitle = t(titleTranslationKey, {tagName: routeLabel, page});
              return (
                <div data-hooks="page" className={`${s.page} ${s.container}`}>
                  {seo.generateHelmet({
                    title: pageSEOTitle,
                    description: t(`${route.tag}_page_seo_description`),
                    url
                  })}
                  {pageHeader}
                  <BasicLayout history={history} />
                </div>
              );
            }}
          />
        </Switch>
        <Subscription data-hooks="subscription" />
        <Fullscreen />
      </main>
    );
  }

  private doUpdate() {
    const {articles, hasResults, sending} = this.props;
    const noArticles = articles.length === 0;
    hasResults(!noArticles);
    sending(false);
    window.scrollTo(0, 0);
  }
}

//@ts-ignore
export default withRouter(withTranslation()(App));
